import React from 'react';
import { PreviewContext } from './context';
import { usePreviewStore } from './hooks';

export function CardPreviewStore(props) {
    const value = usePreviewStore();

    return <PreviewContext.Provider value={value} {...props} />;
}
